/**
 * Redux Store Configuration
 * Central configuration module for the application's Redux store
 * Combines multiple domain-specific reducers into a single state management store
 */

import { configureStore } from "@reduxjs/toolkit";
import notificationsReducer from "./notification-store";
import walletReducer from "./wallet/wallet-slice";
import configReducer from "./config/config-slice";

/**
 * Main Redux store instance
 * Creates and configures the application's Redux store with combined reducers
 * Enables centralized state management across the application
 *
 * @type {import("@reduxjs/toolkit").EnhancedStore}
 * @property {Object} reducer - Combined reducer configuration object
 * @property {Function} reducer.notifications - Handles notification state and operations
 * @property {Function} reducer.wallet - Manages cryptocurrency wallet connection state and interactions
 * @property {Function} reducer.config - Controls application-wide configuration settings
 * @returns {import("@reduxjs/toolkit").EnhancedStore} Configured Redux store instance
 */
const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    wallet: walletReducer,
    config: configReducer,
  },
});

export default store;
